import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CreateInvoice from '../components/Invoice/CreateInvoice';
import * as InvoiceVendorAction from '../actions/invoiceVendorAction';
import * as SnackBarAction from '../actions/snackbarAction';
import CookieLib from '../helpers/cookieLib';

function mapStateToProps(state) {
  const isAdmin =
    state.Chargecard?.userInfo?.has_role ||
    CookieLib.getCookieByKey('has_role') == 'true';
  return {
    ...state.Invoice,
    walletLimit:
      state.Chargecard?.wallet_limit?.[isAdmin ? 'org_limit' : 'user_limit'] ||
      {},
    userInfo: { ...state.Chargecard?.userInfo },
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...InvoiceVendorAction,
      ...SnackBarAction,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateInvoice);
